import { HttpResponseError } from '@vista-digital/http-client';
export async function getResponseErrorBody(error) {
    if (error instanceof HttpResponseError) {
        if (error.statusCode >= 400 && error.statusCode < 500) {
            return await error.body();
        }
    }
    return undefined;
}
//# sourceMappingURL=get-response-error-body.js.map